import { CurrentUser } from 'api/currentUser';
import { FilestackImageData } from 'api/types/shared.types';
import algoliaSearch from 'utils/algoliaSearch';
import { JobFunction } from 'utils/constants';
import getSearchConfig from 'utils/search/getSearchConfig';
import getSearchIndex from 'utils/search/getSearchIndex';
import getSearchLocationOptions from 'utils/search/getSearchLocationOptions';

type ResultItem = {
  objectID: string;
  name: string;
  city: string;
  state: string;
  logo: FilestackImageData;
  orgName: string;
  url: string;
};
const ATTRIBUTES: (keyof ResultItem)[] = [
  'objectID',
  'name',
  'city',
  'state',
  'logo',
  'orgName',
  'url',
];
export const getRecommendedJobs = ({
  currentUser,
  options: { onlyWithLogo, jobFunction },
}: {
  currentUser: CurrentUser | null | undefined;
  options: {
    onlyWithLogo: boolean;
    jobFunction: JobFunction | null | undefined;
  };
}): Promise<ResultItem[]> => {
  const searchConfig = getSearchConfig();
  let locationOptions = {};

  if (
    currentUser &&
    currentUser.searchLocation &&
    currentUser.searchLocation.latitude &&
    currentUser.searchLocation.longitude
  ) {
    locationOptions = getSearchLocationOptions(
      'auto',
      currentUser.searchLocation
    ).locationOptions;
  }

  const filters = [
    onlyWithLogo && '_tags:hasLogo',
    jobFunction && `(functions:'${jobFunction}')`,
  ]
    .filter(Boolean)
    .join(' AND ');
  const queryOptions = {
    index: getSearchIndex(),
    hitsPerPage: 20,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributesToRetrieve: ATTRIBUTES as any as string[],
    facetFilters: [['type:JOB']],
    filters,
    ...locationOptions,
  };
  return algoliaSearch(searchConfig, '', queryOptions)
    .then(({ hits }) => hits)
    .catch();
};
